import { DAY_LABELS } from "../lib/dates";
import { ALL_BLOCKS, isFullDay, isPartialDay } from "../lib/blocks";

/* ───────────────────── CALENDAR MONTH ───────────────────── */
export function CalendarMonth({ month, unavailDates, onToggle, canEdit, playerColors }) {
  const startDay = new Date(month.year, month.month, 1).getDay();
  const cells = [];

  for (let i = 0; i < startDay; i++) cells.push(<div key={"e" + i} />);

  for (let d = 1; d <= month.days; d++) {
    const dk = month.year + "-" + String(month.month + 1).padStart(2, "0") + "-" + String(d).padStart(2, "0");
    // unavailDates can be an object { date: blocks[] } or legacy array
    const blocks = typeof unavailDates === "object" && !Array.isArray(unavailDates)
      ? (unavailDates[dk] || null)
      : (Array.isArray(unavailDates) && unavailDates.includes(dk) ? [...ALL_BLOCKS] : null);
    const isFull = blocks && isFullDay(blocks);
    const isPartial = blocks && isPartialDay(blocks);
    const isUnavail = isFull || isPartial;
    const otherPlayers = playerColors ? playerColors[dk] || [] : [];

    let style = {};
    let cls = "relative flex flex-col items-center justify-center aspect-square rounded-lg text-sm font-medium transition-all border ";
    if (!canEdit) {
      if (isFull) { style = { backgroundColor: "#dc2626", borderColor: "#dc2626", color: "#fff" }; cls += "border-2 cursor-default"; }
      else if (isPartial) { style = { backgroundColor: "#fbbf24", borderColor: "#f59e0b", color: "#78350f" }; cls += "border-2 cursor-default"; }
      else { style = { backgroundColor: "#dcfce7", borderColor: "#bbf7d0", color: "#166534" }; cls += "border-2 cursor-default"; }
    } else if (isFull) {
      style = { backgroundColor: "#dc2626", borderColor: "#dc2626", color: "#fff" };
      cls += "border-2 shadow-md cursor-pointer";
    } else if (isPartial) {
      style = { backgroundColor: "#fbbf24", borderColor: "#f59e0b", color: "#78350f" };
      cls += "border-2 shadow-md cursor-pointer";
    } else {
      style = { backgroundColor: "#dcfce7", borderColor: "#bbf7d0", color: "#166534" };
      cls += "border-2 hover:border-red-300 hover:bg-red-50 cursor-pointer";
    }

    cells.push(
      <button
        key={d}
        onClick={() => canEdit && onToggle(dk)}
        style={style}
        className={cls}
      >
        <span>{d}</span>
        {isPartial && (
          <span className="absolute top-0 right-0.5 text-[9px] font-bold leading-none"
            style={{ color: isFull ? "#fff" : "#92400e" }}>½</span>
        )}
        {otherPlayers.length > 0 && (
          <div className="absolute bottom-0.5 left-1/2 flex gap-0.5" style={{ transform: "translateX(-50%)" }}>
            {otherPlayers.slice(0, 5).map((c, i) => (
              <span key={i} className="block rounded-full" style={{ width: 4, height: 4, backgroundColor: c }} />
            ))}
          </div>
        )}
      </button>
    );
  }

  return (
    <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-4 sm:p-5">
      <h3 className="text-lg font-bold text-gray-800 mb-3">{month.name} {month.year}</h3>
      <div className="grid grid-cols-7 gap-1 mb-2">
        {DAY_LABELS.map((d) => (
          <div key={d} className="text-center text-xs font-semibold text-gray-400 py-1">{d}</div>
        ))}
      </div>
      <div className="grid grid-cols-7 gap-1">{cells}</div>
    </div>
  );
}
